import Call from '../Call';

const AdkBids = {
    get() {
        return Call(`adkBids`);
    },

    save(bid) {
        return Call('adkBids','POST', bid);
    },

    remove(country) {
        return Call(`adkBids/${country}`,'DELETE');
    },
};

export default AdkBids;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkBids.js